class HorizontalContentScroll extends HTMLElement {
  constructor() {
      super();
      this.sticky = null;
      this.horizontal = null;
      this.horizontalScroll = this.horizontalScroll.bind(this);
      this.updateStickyParentHeight = this.updateStickyParentHeight.bind(this);
  }

  connectedCallback() {
    this.sticky = this.querySelector('[horizontal-content-scroll-wrapper]');
    this.horizontal = this.querySelector('[horizontal-content-scroll-content');

    if (!this.sticky || !this.horizontal) {
      console.warn("Required elements not found within the component.");
      return;
    }

    this.updateStickyParentHeight();
    window.addEventListener('resize', this.updateStickyParentHeight);
    document.addEventListener('scroll', this.horizontalScroll);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.updateStickyParentHeight);
    document.removeEventListener('scroll', this.horizontalScroll);
  }

  updateStickyParentHeight() {
    let scrollWidth = this.horizontal.scrollWidth;
    this.style.height = `${scrollWidth}px`;
  }

  getTranslateMultiplier() {
    if (window.innerWidth <= 768) {
      return 1.2;
    } else if (window.innerWidth <= 1024) {
      return 1.0;
    } else {
      return 0.9;
    }
  }

  horizontalScroll() {
    let stickyPosition = this.sticky.getBoundingClientRect().top;

    // Get the value of the CSS variable and convert rem to pixels
    let stickyOffsetRem = getComputedStyle(this.sticky).getPropertyValue('--sticky-header-height');
    let rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    let stickyOffset = parseFloat(stickyOffsetRem) * rootFontSize || 72;

    if (stickyPosition > stickyOffset) {
      return;
    }

    let scrolled = this.getBoundingClientRect().top;
    let scrollWidth = this.horizontal.scrollWidth;
    let maxTranslateX = scrollWidth - window.innerWidth;
    let multiplier = this.getTranslateMultiplier();
    let translateValue = Math.min(maxTranslateX, Math.max(0, (scrollWidth / this.clientHeight) * (-scrolled) * multiplier));
    this.horizontal.style.transform = `translateX(${-translateValue}px)`;
  }
}

customElements.define('horizontal-content-scroll', HorizontalContentScroll);